import React from 'react';
import { Typography, Grid, Link } from '@material-ui/core'
import config from '../../config/config.json';

export default function (props) {
    const ejemplo = [
        { campo: 'nombre', tipo: 'string', valor: 'LAURA', descripcion: 'Nombre del Organismo tropical' },
        { campo: 'categoria', tipo: 'string', valor: 'Tormenta Tropical', descripcion: 'Categoria del organismo tropical en la escala de Saffir-Simpson' },
        { campo: 'lat', tipo: 'float', valor: '19.5', descripcion: 'Latitud del Organismo Tropical' },
        { campo: 'long', tipo: 'float', valor: '75.9', descripcion: 'Longitud del Organismo Tropical' },
        { campo: 'viento_max', tipo: 'float', valor: '180.3', descripcion: 'Vientos máximos sostenidos del Organismo Tropical' },
        { campo: 'presion_min', tipo: 'intiger', valor: '988', descripcion: 'Presión mínima del Organismo Tropical' },
        { campo: 'imagen', tipo: 'url', valor: 'null', descripcion: 'Url de acceso a la imágen...' },
        { campo: 'comentario', tipo: 'string', valor: 'Sin comentarios', descripcion: 'Detalles o alguna descripción del Organismo Tropical' },
        { campo: 'fecha', tipo: 'date', valor: '2021-04-01 16:56:37', descripcion: 'Fecha y hora de ' },
        { campo: 'meteorologo', tipo: 'string', valor: 'Lolo Pérez García', descripcion: 'Nombre completo del meteorologo que informa' },
    ];

    return (
        <>
            <Typography variant="h5" color="initial">
                <code>
                    Ciclones
                </code>
            </Typography>
            <br />

            <Typography variant="subtitle2" color="initial">
                Ciclón(es) vigente(s).
            </Typography>
            <br />

            <Grid container spacing={1}>
                <Grid item sm={1}>
                    <Typography variant="subtitle1" className="getMethod">GET</Typography>
                </Grid>
                <Grid item sm={8}>
                    <Typography variant="subtitle1" className="endPoint">/ciclones</Typography>
                </Grid>
                <Grid item sm={3}>
                    <Typography variant="subtitle1" color="primary">
                        <Link href={`${config.apiBaseUrl}/ciclones`} target="_blank">
                            Pruébalo
                            <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M12.7928 8.50002L8.64637 12.6465L9.35348 13.3536L14.707 8.00004L9.35348 2.64648L8.64637 3.35359L12.7928 7.50002H3V8.50002H12.7928Z" fill="#3f51b5">
                                </path>
                            </svg>
                        </Link>
                    </Typography>
                </Grid>
            </Grid>
            <br />

            <pre>
                {config.apiBaseUrl}/ciclones
            </pre>
            <br />

            <Typography paragraph variant="body2">
                Devuelve una lista de ciclon(es) vigente(s) en caso de que exista. Donde cada ciclón es representado por un objeto.
            </Typography>
            <br />

            <Typography variant="h6" color="initial">
                Ejemplo: <br /> {/* Ejemplo de respuesta */}
                {/* con un Tabs de mui mostrar [cuerpo, cabecera] */}
            </Typography>
            <br />
            <pre>
                [
                <div>{`{`}</div>
                {
                    ejemplo.map((item) => (
                        <div><span className="pre-key">"{item.campo}"</span>: <span className="pre-value">"{item.valor}",</span></div>
                    ))
                }
                <div>{`}`},</div>
                ]
            </pre>

            <Typography variant="h6" color="initial">
                Cada objeto esta formado por:
            </Typography>
            <br />

            <table className="table table-striped table-bordered table-hover">
                <thead>
                    <tr>
                        <th>Campo</th>
                        <th>Tipo</th>
                        <th>Descripción</th>
                    </tr>
                </thead>
                <tbody>
                    {
                        ejemplo.map((item) => (
                            <tr>
                                <td>{ item.campo }</td>
                                <td>{ item.tipo }</td>
                                <td>{ item.descripcion }</td>
                            </tr>
                        ))
                    }
                </tbody>
            </table>
            <br />
        </>
    )
}